// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"c5d5cf7d","260":"dc05097c","668":"204aca70","762":"55846ad4"}[chunkId] + ".js";
};